































import Vue from 'vue';

export default Vue.extend({
  props: ['pagination'],
  data(): {
    currentPage: number;
    maxPage: number;
    pageList: number[];
    firstPage: number;
  } {
    return {
      currentPage: this.pagination.currentPage,
      maxPage: this.pagination.maxPage,
      pageList: this.pagination.pageList,
      firstPage: this.pagination.firstPage,
    };
  },
  watch: {
    currentPage: function () {
      this.changePage();
      this.$emit('changeDataList', this.currentPage);
    },
  },
  methods: {
    prePage() {
      this.currentPage -= 1;
    },
    nextPage() {
      this.currentPage += 1;
    },
    goClickedPage(page: number) {
      this.currentPage = page;
    },
    changePage() {
      this.pageList = [];
      if (this.currentPage < 6) {
        //현재 페이지보다 앞 페이지가 5개보다 적을 때
        for (let page = 1; page < this.currentPage; page++) {
          this.pageList.push(page);
        }
        for (let page = this.currentPage; page <= this.maxPage; page++) {
          if (this.pageList.length == 10) break;
          this.pageList.push(page);
        }
      } else if (this.currentPage + 4 > this.maxPage) {
        //현재 페이지보다 남은 페이지가 4개보다 적을 때
        let pageNumber = this.maxPage - this.currentPage + 1;
        let number = 10 - pageNumber;
        for (let i = number; i > 0; i--) {
          let page = this.currentPage - i;
          if (page == 0) break;
          this.pageList.push(page);
        }
        for (let page = this.currentPage; page <= this.maxPage; page++) {
          this.pageList.push(page);
        }
      } else {
        for (let page = this.currentPage - 5; page <= this.maxPage; page++) {
          if (this.pageList.length == 10) break;
          this.pageList.push(page);
        }
      }
    },
  },
});
